import React from 'react';
import { Link, Text, View } from '@react-pdf/renderer';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import { getEDMSLink } from './Util';

type Props = {
  label?: string;
  value: string;
  placeholder: string;
  isEdms?: boolean;
};

function InputWithLabel({ label, value, placeholder, isEdms }: Props) {
  const { t } = useTranslation();

  return (
    <>
      {label && (
        <View style={[styles.label]}>
          =<Text>{t(label)}</Text>
        </View>
      )}
      <View style={[styles.inputText, value ? {} : styles.lightGray]}>
        {isEdms ? (
          <Link style={styles.link} href={getEDMSLink(value)}>
            EDMS - {value}
          </Link>
        ) : (
          <Text>{value ? value : t(placeholder)}</Text>
        )}
      </View>
    </>
  );
}

export default InputWithLabel;
